<div>
    <h3>{{ 'signingLocation.signingLocation' | transloco }}</h3>
    <form [formGroup]="signingLocation">
        <lib-jurisdiction-selection [appearance]="'outline'" 
            [defaultCountry]="signingCountry" 
            [defaultJurisdiction]="signingJurisdiction"
            [countryFieldName]="'Country'" [jurisdictionFieldName]="'Jurisdiction'" 
            countryFieldToFill="signingCountry" jurisdictionFieldToFill="signingJurisdiction"
            [enabled]="!isDisabled"></lib-jurisdiction-selection>

        <div class="flex-container">
            <div class="validated-form-field-container flex-container">
                <mat-form-field appearance="outline" class="form-field flex-item">
                    <mat-label>{{ 'signingLocation.signingCity' | transloco }}</mat-label>
                    <input matInput [disabled]="isDisabled" formControlName="signingCity" [placeholder]="'signingLocation.signingCity' | transloco"
                        name="signing-city" data-testid="signing-city-field">
                </mat-form-field>
                <lib-error-bubble [control]="signingLocation.controls['signingCity']"
                    [message]="signingCityError$"></lib-error-bubble>
            </div>
            <div class="validated-form-field-container flex-container">
                <mat-form-field appearance="outline" class="form-field flex-item">
                    <mat-label>{{ 'signingLocation.signingDate' | transloco }}</mat-label>
                    <input matInput [disabled]="isDisabled" [matDatepicker]="signingDate" formControlName="signingDate"
                        name="signing-date" [placeholder]="'common.labels.yyyyMmDd' | transloco" data-testid="signing-date-field">
                    <mat-datepicker-toggle matSuffix [for]="signingDate"></mat-datepicker-toggle>
                    <mat-datepicker #signingDate></mat-datepicker>
                </mat-form-field>
                <lib-error-bubble [control]="signingLocation.controls['signingDate']"
                    [message]="signingDateError$"></lib-error-bubble>
            </div>
        </div>
    </form>
</div>